export default __webpack_public_path__ + "assets/edit.1b4d1dd7.svg";